import { resolvePolycountRange } from 'Pods/ThreeDStudio/Services/resolvePolycountRange'

/**
 * Resolves the effective { minimum, maximum, default } polycount range of a
 * generation schema for the given settings, whichever polycount key it declares.
 *
 * @param {Object} generationModelSchema - The schema driving the generation form.
 * @param {Object} settings - { polygonType, isSmartLowPoly }.
 * @returns {Object|undefined} The range, or undefined when the schema declares no
 *   polycount field and when a matching branch declares no node - callers must
 *   leave the current target alone rather than overwrite it with undefined. A
 *   parent-schema fallback (no branch matched) still resolves, so an explicit
 *   Low/Medium/High click clears a target the schema cannot place.
 */
export function resolveActivePolycountRange(generationModelSchema, { polygonType, isSmartLowPoly }) {
  const properties = generationModelSchema?.input_schema?.properties
  const faceCountSchema = properties?.face_count
  const inputSchema = faceCountSchema || properties?.target_polycount

  if (!inputSchema) {
    return undefined
  }

  const schemaKey = faceCountSchema ? 'face_count' : 'target_polycount'

  return resolvePolycountRange(inputSchema, schemaKey, { polygonType, isSmartLowPoly })
}
